import React from "react";
import "./participant.styles.scss";

const Participant = ({ name, user }) => {
  return (
    <div className={`participant ${user ? "user" : null}`}>
      <div className="participant-row">
        <span>{name}</span>
        <div className="row-icons">
          {user ? null : <button>Find </button>}
          <button>Mute </button>
        </div>
      </div>
    </div>
  );
};

export default Participant;
